import { useState, useEffect } from "react";
import SecondaryCurved from "@/assets/backgrounds/SecondaryCurved.svg";
import PageLayout from "@/components/custom/PageLayout";
import { Button } from "@/components/ui/button";
import CheckInCard from "./CheckInCarAllocationCard";
import { BottomNav } from "@/components/custom/BottomNav";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import CheckInService from "@/services/api/CheckInService";
import { useNavigate } from "react-router-dom";
import { useHubDetails } from "@/redux/hooks/useSupervisorDetails";
import SuccessErrorScreen from "@/components/custom/SuccessErrorScreen";

const CheckInCarAllocation = () => {
  const checkInDetails = useSelector(
    (state: RootState) => state.checkInDetails
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [odo, setOdo] = useState<number>(checkInDetails.odometer || 0);
  const [soc, setSoc] = useState<number>(checkInDetails.soc || 0);
  const navigate = useNavigate();
  const hubDetails = useHubDetails();

  useEffect(() => {
    setOdo(checkInDetails.odometer || 0);
    setSoc(checkInDetails.soc || 0);
  }, [checkInDetails]);

  const handleCheckInClick = async () => {
    setLoading(true);
    setError(null);
    try {
      const reqBody = {
        et_id: checkInDetails.et_id as string,
        token: checkInDetails.token as string,
        hub: hubDetails?.name as string,
        edited_odometer_reading: odo,
        edited_soc: soc,
      };

      const response = await CheckInService.confirmCheckIn(reqBody);

      if (response.success) {
        setSuccess(true);
      } else {
        setError("Failed to confirm check-in. Please try again.");
      }
    } catch (error) {
      console.error("Failed to confirm check-in", error);
      setError("Failed to confirm check-in. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {success ? (
        <SuccessErrorScreen message="Check-in successful" type={1} />
      ) : (
        <>
          {/* Cover Image */}
          <div className="relative w-full">
            <img
              src={SecondaryCurved}
              alt="Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center mt-[22rem]">
              <CheckInCard
                {...checkInDetails}
                odometer={odo}
                setOdo={setOdo}
                soc={soc}
                setSoc={setSoc}
                hubName={hubDetails?.name as string}
              />
            </div>
          </div>
          {/*Body*/}
          <PageLayout>
            <div className="mt-96">
              <div className="flex flex-col justify-center items-center gap-4">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={handleCheckInClick}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Check In"}
                </Button>
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
              </div>
            </div>
          </PageLayout>
          <BottomNav active={2} />
        </>
      )}
    </>
  );
};

export default CheckInCarAllocation;
